import i18n from "i18next";

import type { Position } from "api/services/content/schemas/shared";

export function translatePosition(position: Position): string {
  const keyMap: Record<Position, string> = {
    lying: i18n.t("library.exercises.fields.position_options.lying"),
    sitting: i18n.t("library.exercises.fields.position_options.sitting"),
    standing: i18n.t("library.exercises.fields.position_options.standing"),
  };

  return keyMap[position] || "";
}
